import { AlkLogger, uuidv4 } from '@alk/core';
import { getBaseUrl, getIframeCommunication } from '../../../helpers';
import { getMessageSystemTypeClientHandler } from './worker-channel-system/worker-channel-system-client';
import { WorkerChannelProviderService } from '../../channel';
import { IFRAME_NAME } from '../../../constants';
import { isIComApiMessage, isIComApiMessageSystem } from './worker-channel-hub.utils';
export class WorkerChannelHubService {
    constructor(url) {
        var _a, _b;
        this.channels = new Map();
        this.ready = false;
        this.retry = 10;
        if (!Boolean(url)) {
            throw 'need a valid URL';
        }
        this.iframeSrc = new URL(url);
        (_a = this.$iframeCommunication) !== null && _a !== void 0 ? _a : (this.$iframeCommunication = getIframeCommunication(IFRAME_NAME, this.iframeSrc));
        this.domain = getBaseUrl(new URL((_b = document === null || document === void 0 ? void 0 : document.location) === null || _b === void 0 ? void 0 : _b.origin));
        this.listenToIframe();
    }
    listenToIframe() {
        window.addEventListener('message', (event) => {
            AlkLogger.debug('WorkerChannelHubService#received message', event);
            if (isIComApiMessage(event.data)) {
                this.channels.get(event.data.channel).triggerRegisteredTopic(event.data);
                return;
            }
            else if (isIComApiMessageSystem(event.data)) {
                getMessageSystemTypeClientHandler(event.data)(this);
                return;
            }
            AlkLogger.error('received a wrong message', event);
        });
    }
    connectToChannel(channelLabel) {
        AlkLogger.debug('%cWorkerChannelHubService#WorkerChannelHubService', 'background: black; color: deepskyblue');
        return this.retryConnectToChannel(channelLabel, 10);
    }
    retryConnectToChannel(channelLabel, retry) {
        return new Promise((resolve, reject) => {
            if (retry < 1) {
                reject('cannot connect to the COM API');
            }
            if (!this.channels.has(channelLabel)) {
                if (!this.ready) {
                    setTimeout(() => resolve(this.retryConnectToChannel(channelLabel, retry - 1)), 500);
                }
                else {
                    const newChannel = new WorkerChannelProviderService(channelLabel, this.systemDispatch.bind(this), getBaseUrl(this.iframeSrc));
                    this.systemDispatch('channelSubscriptionRequest', channelLabel);
                    this.channels.set(channelLabel, newChannel);
                    resolve(this.channels.get(channelLabel));
                }
            }
            else {
                resolve(this.channels.get(channelLabel));
            }
        });
    }
    async systemDispatch(type, message, id) {
        AlkLogger.debug('WorkerChannelHubService#systemDispatch', type, message);
        const action = {
            id: id !== null && id !== void 0 ? id : uuidv4(),
            type,
            message: message !== null && message !== void 0 ? message : '',
        };
        this.$iframeCommunication.contentWindow.postMessage(action, this.iframeSrc.origin);
    }
}
